const newClamp = (min: number, max: number) => (value: number) =>
  Math.min(Math.max(value, min), max);

const decimalClamp = newClamp(0, 1);
export const decimalToPercent = (decimal: number) => {
  const clampedDecimal = decimalClamp(decimal);
  return `${clampedDecimal * 100}%`;
};
